export const DEBTOR = 'debtor';
export const ATTORNEY = 'attorney';
export const CLIENT = 'client';
export const STATUTELIMITATION = 'statutelimitation';
export const POEADDRESS = 'poeaddress';
export const ACCOUNTSUMMARY = 'accountsummary';
export const ACCOUNTSTATUS = 'accountstatus';
export const ACCOUNTMULTIPLES = 'accountmultiples';
export const DOCUMENT = 'document';
export const LOOKUP = 'lookup';
export const TIE = 'tie';
export const UNTIE = 'untie';
export const PAYMENT = 'payment';
export const DISPOSITION = 'disposition';
export const CLIENT_MAINTENANCE = 'maintenance';
export const AR = 'ar';
export const UDW = 'udw';
export const GLOBAL_FIELD = 'globalfield';
export const REPORT_TYPE = 'REPORT_TYPE';
export const ACCESS_METHOD = 'ACCESS_METHOD';
export const DATA_REPOSITORY = 'data-repository';
